var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('awesome',{attrs:{"icon":[_vm.getType, _vm.getIcon]}}):_c('i',{staticClass:"icon",class:[_vm.getType, _vm.getIcon]})
}
var staticRenderFns = []

export { render, staticRenderFns }